import { gql } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useEffect, useState } from 'react';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH, pathURL } from 'src/common/constants';
import images from 'src/common/images';
import { MemberType } from 'src/common/number-enum';
import { getUserInfo } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

export type MstUser = {
  mu_mail: string;
  mu_user_id: string;
  mu_user_nm: string;
  mu_office_cd: string;
  mu_admin_kb: number;
  mo_office_nm: string;
};

type LocationProps = {
  pathname: string;
  state: {
    from: Location;
  };
};

const NavigationBar = () => {
  const { isOpen, setIsOpen } = useDropdownMenu(1);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const [mstUser, setMstUser] = useState<MstUser>({
    mo_office_nm: '',
    mu_admin_kb: 0,
    mu_mail: '',
    mu_office_cd: '',
    mu_user_id: '',
    mu_user_nm: '',
  });
  const [backPageName, setBackPageName] = useState<string>('');
  const location = useLocation() as unknown as LocationProps;
  const handleSignOut = () => {
    signOut();
    navigate(LOGIN_PATH, { replace: true });
  };

  const [searchMstUser, { data: mstUserData }] = useAppLazyQuery({ query: gql(getUserInfo) });

  const goBack = () => {
    if (backPageName === `${pathURL.QUOTATION_LIST.name}へ戻る`) {
      navigate(pathURL.QUOTATION_LIST.pathName);
    } else if (backPageName === `${pathURL.ADMIN_CONSOLE.name}へ戻る`) {
      navigate(pathURL.ADMIN_CONSOLE.pathName);
    }
  };

  const directToAdminMenu = () => {
    navigate(pathURL.ADMIN_CONSOLE.pathName, { state: { from: location } });
  };

  useEffect(() => {
    if (mstUserData) {
      setMstUser({
        mu_mail: mstUserData.getUserInfo[0]?.mu_mail,
        mu_user_id: mstUserData.getUserInfo[0]?.mu_user_id,
        mu_user_nm: mstUserData.getUserInfo[0]?.mu_user_nm,
        mu_office_cd: mstUserData.getUserInfo[0]?.mu_office_cd,
        mu_admin_kb: mstUserData.getUserInfo[0]?.mu_admin_kb,
        mo_office_nm: mstUserData.getUserInfo[0]?.mo_office_nm,
      });
    }
  }, [mstUserData]);

  useEffect(() => {
    searchMstUser({ variables: { input: { mu_mail: user?.username } } });
  }, [user]);

  useEffect(() => {
    if (
      location.pathname === pathURL.ADMIN_CONSOLE.pathName ||
      location.pathname === pathURL.QUOTATION_INPUT.pathName
    ) {
      setBackPageName(`${pathURL.QUOTATION_LIST.name}へ戻る`);
    } else if (location.pathname === pathURL.QUOTATION_LIST.pathName) {
      setBackPageName('');
    } else {
      setBackPageName(`${pathURL.ADMIN_CONSOLE.name}へ戻る`);
    }
  }, [location]);

  return (
    <div className="z-40">
      <div className="bg-[#66a1ffb3] h-[100px] flex p-[20px] justify-between items-center ">
        <p className="text-[40px] text-white">QS2</p>
        <div className="flex items-center">
          <button onClick={goBack} className="mr-[20px] text-white">
            {backPageName}
          </button>
          <p className="text-white">{user?.username}</p>
          <button
            className="ml-[10px]"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <img src={images.icUser} alt="" className="w-10" />
          </button>
        </div>
      </div>
      <div
        className={`${
          isOpen ? 'visible' : 'invisible'
        } z-1 absolute right-[0px] bg-white p-[10px] shadow-lg flex-col flex`}
      >
        <p>{mstUser?.mu_user_id}</p>
        <p>{mstUser?.mu_user_nm}</p>
        <p>{mstUser?.mo_office_nm}</p>
        {mstUser?.mu_admin_kb === MemberType.ADMIN && (
          <button onClick={directToAdminMenu}>
            <p className="text-[#1da1f2] underline decoration-[1px] text-left">管理画面へ</p>
          </button>
        )}
        <button onClick={handleSignOut}>
          <p className="text-[#1da1f2] underline decoration-[1px] text-left">サインアウト</p>
        </button>
      </div>
    </div>
  );
};

export default NavigationBar;
